import { Transition } from "@headlessui/react";
import { QuestionMarkCircleIcon } from "@heroicons/react/20/solid";
import React, { useEffect, useState } from "react";
import uuid from "react-uuid";
import { AXIOS_POST, AXIOS_UPDATE } from "../server/api/crud";
import { useDispatch } from "react-redux";
import { setComments, setCommentsUpdate } from "../redux/commentSlice";
import Swal from "sweetalert2";
import moment from "moment";
import TextEditorAll from "./TextEditorAll";
import RP_Avatar from "./RP_Avatar";
import { createComment } from "../apiCalls/commentsApi";

const Beantwoorden = ({user, admin,commentaar, setUpdateComment}) => {
  const [newComments, setNewComments] = useState({
    id: '',
    user: user?.userdetails_full_name,
    user_id: user.user_id,
    admin: admin?.full_name,
    admin_id: admin?.user_id,
    author_id: admin?.user_id,
    avatar: admin?.avatar,
    body: "",
    datetime: null
  });

  useEffect(() => {
    if(commentaar?.id){
      setNewComments(commentaar)
    }
 
  }, [commentaar])
  

  const dispatch = useDispatch();

  const resetForm = () => {
    setNewComments({
      id: '',
      user: user?.userdetails_full_name,
      user_id: user.user_id,
      admin: admin?.full_name,
      admin_id: admin?.user_id,
      author_id: admin?.user_id,
      avatar: admin?.avatar,
      body: "",
      datetime: null
    })
  }

  const handleSubmit = async (e) => {
    createComment(e,newComments,commentaar,setUpdateComment,resetForm, dispatch, setComments, setCommentsUpdate);  
  };

  return (
    <div className="border-t border-wa-border bg-wa-panel px-4 py-6 sm:px-6">
      <div className="flex space-x-3">
        <div className="flex-shrink-0">
          <RP_Avatar avatar={admin?.avatar} size="10" />
        </div>
        <div className="min-w-0 flex-1">
          <form onSubmit={handleSubmit} className="w-full">
            <div className="relative">
              <label htmlFor="body" className="sr-only">
                Beantwoorden op
              </label>
              <div className="flex-1">
              <TextEditorAll p_height="40vh" setValue={setNewComments} value={newComments?.body} editorKey={'body'}/>
              </div>
            </div>
            <div className="relative mt-3 flex flex-1 items-center justify-between">
              <p className="inline-flex items-start space-x-2 text-sm text-wa-muted">
                <QuestionMarkCircleIcon
                  aria-hidden="true"
                  className="h-5 w-5 flex-shrink-0 text-wa-muted"
                />
                <span>Voeg paar notities toe voor uw collega's</span>
              </p>
              <button
                type="submit"
                className="inline-flex items-center justify-center rounded-md bg-wa-accent px-3 py-2 text-sm font-semibold text-wa-onaccent shadow-sm transition-colors hover:bg-wa-accent/90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-wa-accent"
              >
                Opslaan
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Beantwoorden;
